import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Button, Card, Grid } from '@material-ui/core'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import ChooseAPaymentMethod from './ChooseAPaymentMethod'
import OrderSummary from './OrderSummary'
import Loader from '../../Loader/Loader'

const AdditionalCharge = ({
  charge,
  bindPurchaseOrderNumber,
  purchaseOrderNumber,
  purchaseOrderFiles,
  setPurchaseOrderFiles,
  setPaymentMethod,
  paymentError,
  processingPayment,
  handleProceedClick,
}) => {
  const [showModal, setShowModal] = useState(false)

  const { success: addPODocsSuccess } = useSelector(
    (state) => state.projectAddPODocs
  )

  useEffect(() => {
    if (addPODocsSuccess) {
      setShowModal(false)
    }
  }, [addPODocsSuccess])

  return (
    <>
      <Grid item xs={12}>
        <Card className="p-16 m-t-24">
          <div className="flex">
            <p className="primary m-r-24">Additional charge: </p>
            <p className="primary">
              {charge.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}
            </p>
          </div>

          <div className="flex flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowModal(true)}
            >
              Pay
            </Button>
          </div>
        </Card>
      </Grid>

      <ModalPopUp
        title="Pay additional charge"
        setShowModal={setShowModal}
        showModal={showModal}
        variant="wide"
      >
        <Grid container spacing={4}>
          <Grid item xs={8}>
            <ChooseAPaymentMethod
              bindPurchaseOrderNumber={bindPurchaseOrderNumber}
              files={purchaseOrderFiles}
              setFiles={setPurchaseOrderFiles}
              setPaymentMethod={setPaymentMethod}
              paymentError={paymentError}
              noCollapse={true}
            />
          </Grid>
          <Grid item xs={4}>
            <OrderSummary charge={charge} />
          </Grid>
        </Grid>

        <div className="flex flex-end m-t-40">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            className="m-l-24"
            onClick={handleProceedClick}
            disabled={purchaseOrderNumber === ''}
          >
            {processingPayment ? <Loader /> : 'Proceed'}
          </Button>
        </div>
      </ModalPopUp>
    </>
  )
}

export default AdditionalCharge
